/**
 * Orders Stats Component
 */

import { StatsWidget, StatsWidgetGrid, cn } from '@spcc/uikit'
import { Clock, Package, CheckCircle } from '@spcc/uikit'
import { useTranslation } from '@spcc/core'
import type { OrdersStatsProps } from '../types'

export function OrdersStats({
  stats,
  activeFilter,
  onStatusFilter,
}: OrdersStatsProps) {
  const { t } = useTranslation()

  return (
    <StatsWidgetGrid columns={3}>
      <StatsWidget
        label={t('orders.pending')}
        value={stats.pending}
        icon={Clock}
        color="slate"
        onClick={() => onStatusFilter('pending')}
        className={cn(activeFilter === 'pending' && 'ring-2 ring-slate-500')}
      />
      <StatsWidget
        label={t('orders.processing')}
        value={stats.processing}
        icon={Package}
        color="amber"
        onClick={() => onStatusFilter('processing')}
        className={cn(activeFilter === 'processing' && 'ring-2 ring-amber-500')}
      />
      <StatsWidget
        label={t('orders.delivered')}
        value={stats.delivered}
        icon={CheckCircle}
        color="emerald"
        onClick={() => onStatusFilter('delivered')}
        className={cn(activeFilter === 'delivered' && 'ring-2 ring-emerald-500')}
      />
    </StatsWidgetGrid>
  )
}
